import React, { useContext } from 'react'

import { LocaleContext } from '../locale/i18n'
import { staticPagePaths } from '../locale/pathing'
import { StaticPage } from '../logic/staticPage'

import Button from './Button'

export const LoginButton = () => {
  const { locale, t } = useContext(LocaleContext)

  return (
    <Button
      onClick={() => {
        // gastby navigation adds /portal to history causing a redirect loop
        location.href = staticPagePaths[StaticPage.PORTAL][locale]
      }}
    >
      {t('portal.loginButton')}
    </Button>
  )
}
